 
(function () {
  'use strict'; 
  var SECTION_CLASSES = ['shopify-section--marquee', 'shopify-section--announcement-bar'];
  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DEFAULT_PPS = 60;

  function root() {
    return document;
  }

  function scope(node) {
    return node && node.querySelectorAll ? node : document;
  }
 
  function groupWidth(group) {
    return group ? group.getBoundingClientRect().width : 0;
  }

  function buildMarquee(content) {
    var track = content.querySelector('.marquee-track');
    if (!track) return;

    // The first .marquee-group authored in Liquid is our source of truth.
    var source = track.querySelector('.marquee-group[data-marquee-source]') ||
                 track.querySelector('.marquee-group');
    if (!source) return;

    // Tag the source so we can find it again on re-measure.
    source.setAttribute('data-marquee-source', '');

    // Remove every other .marquee-group: the Liquid static duplicate (fallback) and
    // any previously generated clones. JS now owns the count. Idempotent on resize /
    // section reload.
    var groups = track.querySelectorAll('.marquee-group');
    for (var i = 0; i < groups.length; i++) {
      if (groups[i] !== source) {
        track.removeChild(groups[i]);
      }
    }

    var containerWidth = content.getBoundingClientRect().width;
    var oneGroup = groupWidth(source);
    if (oneGroup <= 0 || containerWidth <= 0) return;
 
    var copiesPerHalf = Math.ceil(containerWidth / oneGroup);
    if (copiesPerHalf < 1) copiesPerHalf = 1;
    var totalCopies = copiesPerHalf * 2;  
 
    for (var c = 1; c < totalCopies; c++) {
      var clone = source.cloneNode(true);
      clone.removeAttribute('data-marquee-source');
      clone.setAttribute('data-marquee-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    }

    // Constant speed: one full loop moves the track by 50% of its width. Half the
    // track is copiesPerHalf group-widths => data-marquee-source = copiesPerHalf * oneGroup.
    // duration = distance / speed keeps pixels-per-second constant regardless of
    // item count or viewport width.
    var pps = parseFloat(content.getAttribute('data-marquee-pps')) || DEFAULT_PPS;
    if (pps <= 0) pps = DEFAULT_PPS;
    var distance = copiesPerHalf * oneGroup;
    var duration = distance / pps;
    track.style.animationDuration = duration + 's';
  }

  function initContent(content) {
    if (REDUCED_MOTION) {
      content.setAttribute('data-marquee-init', '1');
      return;
    }
    buildMarquee(content);
    content.setAttribute('data-marquee-init', '1');
  }

  function destroyContent(content) {
    var track = content.querySelector('.marquee-track');
    if (track) {
      var clones = track.querySelectorAll('.marquee-group[data-marquee-clone]');
      for (var i = 0; i < clones.length; i++) {
        track.removeChild(clones[i]);
      }
      track.style.animationDuration = '';
    }
    content.removeAttribute('data-marquee-init');
  }

  function init(node) {
    var contents = scope(node).querySelectorAll('.marquee-content');
    for (var i = 0; i < contents.length; i++) {
      initContent(contents[i]);
    }
  }

  function destroy(node) {
    var contents = scope(node).querySelectorAll('.marquee-content');
    for (var i = 0; i < contents.length; i++) {
      destroyContent(contents[i]);
    }
  }
 
  var resizeTimer = null;
  function onResize() {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      init(document);
    }, 150);
  }

  function isSection(el) {
    if (!el || !el.classList) return false;
    for (var i = 0; i < SECTION_CLASSES.length; i++) {
      if (el.classList.contains(SECTION_CLASSES[i])) return true;
    }
    return false;
  }

  function closestSection(el) {
    return el && el.closest ? el.closest('.' + SECTION_CLASSES.join(', .')) : null;
  }

  function boot() {
    init(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Re-measure once fonts/images settle (widths change after load).
  window.addEventListener('load', function () { init(document); });
  window.addEventListener('resize', onResize);

  document.addEventListener('shopify:section:load',   function (e) { if (!isSection(e.target)) return; destroy(e.target); init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { if (!isSection(e.target)) return; destroy(e.target); });
  document.addEventListener('shopify:section:select', function (e) { if (!isSection(e.target)) return; init(e.target); });
  document.addEventListener('shopify:block:select',   function (e) { var s = closestSection(e.target); if (s) { destroy(s); init(s); } });
  document.addEventListener('shopify:block:deselect', function (e) { var s = closestSection(e.target); if (s) { destroy(s); init(s); } });
})();
